import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { AuthProvider, AuthCallback } from "@/AuthContext";

// Detected synchronously at module load (not inside a useEffect) so the
// Google OAuth callback is handled on the very first render -- see
// AuthContext.jsx docstring.
const isGoogleAuthCallback = window.location.hash?.includes("session_id=");

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      {isGoogleAuthCallback ? <AuthCallback /> : <App />}
    </AuthProvider>
  </React.StrictMode>,
);
